import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=15b1bb03&scoped=true"
import script from "./change_password.vue?vue&type=script&lang=js"
export * from "./change_password.vue?vue&type=script&lang=js"
import style0 from "./change_password.vue?vue&type=style&index=0&id=15b1bb03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1bb03",
  null
  
)

export default component.exports